import { render, staticRenderFns } from "./student-hour.vue?vue&type=template&id=1b6a4578&scoped=true"
import script from "./student-hour.vue?vue&type=script&lang=js"
export * from "./student-hour.vue?vue&type=script&lang=js"
import style0 from "./student-hour.vue?vue&type=style&index=0&id=1b6a4578&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a4578",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b6a4578')) {
      api.createRecord('1b6a4578', component.options)
    } else {
      api.reload('1b6a4578', component.options)
    }
    module.hot.accept("./student-hour.vue?vue&type=template&id=1b6a4578&scoped=true", function () {
      api.rerender('1b6a4578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/student-hour.vue"
export default component.exports